// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"c025acf4","144":"0e263816","150":"7f173444","174":"aaef293d","257":"b99972af","394":"384666b0","453":"401c7001","456":"8ffe27c0","496":"a346a7b9","513":"c60b3748","976":"7464fdfa"}[chunkId] + ".chunk.js";
};